import { getNamedContext } from '../getNamedContext';

export const HeaderShownContext = getNamedContext('HeaderShownContext', false);
